// Angular
import { NgModule } from '@angular/core';

// Afidium
import { DatesService } from './dates.service';
import { DateParserModule } from 'libraries/service/date/dateParser.module';

@NgModule({
    imports: [DateParserModule],
    providers: [DatesService],
})
export class DatesModule { }